import * as React from "react";
import { observer } from "mobx-react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  withStyles,
  Tooltip,
  Button,
} from "@material-ui/core";
import { TakeOffStore } from "modules/takeOff/TakeOffStore";
import { ModelMapStore } from "modules/modelMap/ModelMapStore";
import i18n from "i18n";
import * as _ from "lodash";
import { formatNumber } from "utils/MathUtils";

const styles = (theme) => ({
  rowRoot: {
    height: "25px",
    "& > :last-child": {
      padding: "0px",
      borderRight: "0",
    },
  },
  cellRoot: {
    padding: "0px",
    borderRight: "1px solid #e0e0e0",
  },
  table: {
    fontFamily: "Roboto",
    float: "left" as any,
  },
  tableHead: {
    fontSize: "12px",
    color: "#5c5c5c",
    "& th": {
      padding: "15px",
      border: "0px",
    },
  },
  thLink: {
    width: "25px",
  },
  tableBody: {
    fontSize: "13px",
    color: "#666",
    "& > :first-child": {
      borderTop: "1px solid #e0e0e0",
    },
  },
  linkIcon: {
    fontSize: "15px",
    color: "#5c5c5c",
    display: "block",
    margin: "auto",
  },
  button: {
    height: "36px",
    width: "136px",
    marginBottom: 50,
    marginTop: 36,
    background: "#ABC200",
    "&:hover": {
      background: "#92A501",
    },
  },
  input: {
    outlineStyle: "none" as any,
    paddingRight: "10px",
    fontSize: "13px",
    color: "#666",
    height: "24px",
    width: "100%",
    border: "0",
    backgroundColor: "unset",
  },
  cellDisabled: {
    backgroundColor: "rgba(0,0,0,0.02)",
    display: "flex",
    alignItems: "center",
  },
  link: {
    display: "flex",
    paddingRight: "10px",
    fontSize: "13px",
  },
  imgFilter: {
    paddingLeft: "10px",
  },
  blurryText: {
    textShadow: "0 0 32px",
    color: "transparent",
    whiteSpace: "nowrap" as any,
  },
  searchTitle: {
    fontFamily: "Roboto",
    fontSize: "14px",
    fontWeight: 700,
    color: "#212121",
    marginBottom: "5px",
  },
  searchSubtitle: {
    fontFamily: "Roboto",
    fontSize: "11px",
    fontWeight: 300,
    color: "#5c5c5c",
    width: "68%",
  },
  searchNotFound: {
    display: "flex",
    alignItems: "center" as any,
    flexDirection: "column" as any,
    textAlign: "center" as any,
    paddingTop: "calc(10vh)",
  },
  checkField: {
    opacity: 0,
    float: "right" as any,
  },
  fieldPicker: {
    lineHeight: "44px" as any,
    paddingLeft: "44px",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.05)",
    },
    "&:hover button": {
      opacity: 1,
      float: "right" as any,
    },
  },
  overflow: {
    width: "calc(100vw * 0.6)", // 60% da largura da tela
    outlineStyle: "none" as any,
    paddingRight: "10px",
    fontSize: "13px",
    color: "#666",
    height: "24px",
    lineHeight: "24px",
    border: "0",
    backgroundColor: "unset",
    display: "block",
    whiteSpace: "nowrap" as any,
    textOverflow: "ellipsis",
    overflow: "hidden",
  },
});

type IProps = {
  classes: any;
  columns: Array<{
    label: string;
    dataKey: string;
    ref: string;
    disabled?: boolean;
    link?: { condition: Function; url: Function };
    align: "center" | "left" | "right";
    width?: number;
    numeric?: Boolean;
  }>;
  onChange: any;
};

@observer
class TakeOffTableFormat extends React.Component<IProps> {
  state = {
    inputValue: "",
    searchResults: [],
    searchValue: "",
  };

  private firstInputDesc: any;

  constructor(props) {
    super(props);
    this.firstInputDesc = React.createRef();
  }

  private setFirstInputDescRef = (index) => (el) => {
    if (index === 0) {
      this.firstInputDesc = el;
    }
  };

  handleInputFocus = (line, value) => (e) => {
    if (
      ModelMapStore.selectedFormatLine !== undefined &&
      ModelMapStore.selectedFormatLine.line.index !== line.index
    ) {
      if (
        ModelMapStore.selectedFormatLine.target.parentElement.parentElement !==
        null
      )
        ModelMapStore.selectedFormatLine.target.parentElement.parentElement.style.backgroundColor =
          "unset";
    } else if (
      ModelMapStore.selectedFormatLine === undefined &&
      line.index > 0
    ) {
      (
        this.firstInputDesc as any
      ).parentElement.parentElement.style.backgroundColor = "unset";
    }

    ModelMapStore.selectedFormatLine = { line: line, target: e.target };

    e.target.parentElement.parentElement.style.backgroundColor =
      "rgba(237, 242, 203, 1)";
    this.setState({ inputValue: value });
  };

  handleInputBlur = (line, inputField) => (e) => {
    if (this.state.inputValue !== e.target.value) {
      let target = e.target;
      this.updateFormatLine(inputField, line, target);
      return;
    }
  };

  handleSearchChange = (e) => {
    let searchValue = e.target.value;
    let searchResults = TakeOffStore.takeOffModelMap
      ? TakeOffStore.takeOffModelMap.data.fields.filter((field) =>
          field.toLowerCase().includes(searchValue.toLowerCase())
        )
      : [];
    this.setState({ searchValue: searchValue, searchResults: searchResults });
  };

  handleClickAddField = (field) => {
    let target =
      ModelMapStore.selectedFormatLine !== undefined
        ? ModelMapStore.selectedFormatLine.target
        : this.firstInputDesc;
    if (target !== undefined) {
      target.value = target.value + "[" + field + "]";
      let line =
        ModelMapStore.selectedFormatLine !== undefined
          ? ModelMapStore.selectedFormatLine.line
          : ModelMapStore.modelMapFormat[0];
      // let inputField = target.id.indexOf('desc') > 0 ? 'desc' : 'qtt'
      var teste = "";
      if (target.id.indexOf("desc") < 0) {
        if (target.id.indexOf("qtt") < 0) {
          teste = "unit";
        } else {
          teste = "qtt";
        }
      } else {
        teste = "desc";
      }

      let inputField = teste;
      this.updateFormatLine(inputField, line, target);
    }
  };

  private updateFormatLine(inputField: any, line: any, target: any) {
    let format = ModelMapStore.modelMapFormat;
    if (inputField === "desc") {
      line.description = target.value;
    } else if (inputField === "unit") {
      line.unit = target.value;
    } else {
      line.quantity = target.value;
    }
    format[line.index] = line;
    ModelMapStore.modelMapFormat = format;
  }

  render() {
    const { classes } = this.props,
      rowClasses = { root: classes.rowRoot },
      cellClasses = { root: classes.cellRoot };

    const TOP_HEADER = 113;
    let takeOffModelMapId = TakeOffStore.takeOffModelMap
      ? TakeOffStore.takeOffModelMap.id
      : "";

    let indexSelected = TakeOffStore.takeOffFormatedList.findIndex(
      (i) => i.id == takeOffModelMapId
    );

    let list = TakeOffStore.takeOffFormatedList[indexSelected]
      ? TakeOffStore.takeOffFormatedList[indexSelected].data
      : new Array();

    return (
      <div style={{ position: "relative", width: "100%" }}>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "calc(100vh - " + TOP_HEADER + "px - 122px)",
          }}
        >
          <TableHead className={classes.tableHead}>
            <TableRow classes={rowClasses}>
              <TableCell
                key={"header_description"}
                style={{
                  textAlign: "left",
                  whiteSpace: "nowrap",
                  width: "100%",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                Descrição
              </TableCell>
              <TableCell
                key={"header_quantity"}
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  paddingLeft: "15px",
                  minWidth: "160px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                Quantidade
              </TableCell>
              <TableCell
                key={"header_unity"}
                style={{
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  paddingLeft: "15px",
                  minWidth: "160px",
                  borderBottom: "1px solid #e0e0e0",
                }}
              >
                Unidade
              </TableCell>
            </TableRow>
          </TableHead>

          <div
            style={{
              position: "relative",
              height: "calc(100vh - (" + TOP_HEADER + " +  51 + 122)px)",
              overflowY: "scroll",
            }}
          >
            <Table
              className={classes.table}
              style={{
                overflowY: "scroll",
              }}
            >
              <tbody className={classes.tableBody} ref={"tableBody"}>
                {list.map((line, index) => {
                  return this.renderTableRow(
                    rowClasses,
                    line,
                    cellClasses,
                    classes,
                    index
                  );
                })}
              </tbody>
            </Table>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginLeft: "calc(50% - 136px)",
            position: "fixed",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            className={this.props.classes.button}
            onClick={() => {
              TakeOffStore.isFormating = true;
            }}
          >
            {i18n.editto}
          </Button>
        </div>
      </div>
    );
  }

  private renderTableRow(
    rowClasses: { root: any },
    line: any,
    cellClasses: { root: any },
    classes: any,
    index: number
  ): JSX.Element {
    let value = "";
    if (
      line.unit !== " " &&
      line.resultQuantity !== "" &&
      !isNaN(Number(line.resultQuantity))
    ) {
      value = formatNumber(line.resultQuantity);
    } else {
      value = line.resultQuantity;
    }

    return (
      <TableRow
        classes={rowClasses}
        key={line.listIndex}
        style={{
          backgroundColor:
            TakeOffStore.selectedColumn === undefined && index === 0
              ? "rgba(237, 242, 203, 1)"
              : "unset",
        }}
      >
        <TableCell
          classes={cellClasses}
          key={line.listIndex + "." + line.description}
        >
          {line.description.length > 117 ? (
            <Tooltip title={line.description}>
              <div
                style={{
                  paddingLeft:
                    (TakeOffStore.getFormatLevel(line.parentListIndex) + 1) *
                    15,
                }}
                className={classes.overflow}
              >
                {line.description}
              </div>
            </Tooltip>
          ) : (
            <input
              ref={this.setFirstInputDescRef(index)}
              id={"input-desc-" + index}
              type="text"
              readOnly
              className={classes.input}
              defaultValue={line.description}
              style={{
                paddingLeft:
                  (TakeOffStore.getFormatLevel(line.parentListIndex) + 1) * 15,
              }}
            />
          )}
        </TableCell>

        <TableCell
          classes={cellClasses}
          key={line.index + "." + value}
          style={{ width: 160 }}
        >
          {
            <input
              id={"input-qtt-" + index}
              type="text"
              readOnly
              className={classes.input}
              defaultValue={line.isStage ? "" : value}
              style={{ paddingLeft: 15, textAlign: "right" }}
            />
          }
        </TableCell>

        <TableCell
          classes={cellClasses}
          key={line.listIndex + "." + line.unit}
          style={{ width: 160 }}
        >
          {
            <input
              id={"input-unit-" + index}
              type="text"
              readOnly
              className={classes.input}
              defaultValue={line.unit}
              style={{ paddingLeft: 15, textAlign: "right" }}
            />
          }
        </TableCell>
      </TableRow>
    );
  }
}
export default withStyles(styles)(TakeOffTableFormat);



// WEBPACK FOOTER //
// ./src/modules/takeOff/components/layouts/TakeOffTableFormat.tsx